<template>
    <div class="v-file">
        <div class="v-file__content">
            <img src="@/assets/images/icons/document-black.svg" alt="document">
            <div class="v-file__text">
                <div class="v-file__title">{{ file.filename || file.name }}</div>
                <div class="v-file__size">{{ declensionFiles(count) }}</div>
            </div>
        </div>


        <div class="v-file__options">
          <div class="v-file__form-bottom-upload-options">
            <div @mouseleave="title = false" @mousemove="title = true" class="v-file__hover-menu" v-if="info">
              <img src="@/assets/images/icons/info.svg" alt="title" />
              <div v-if="title" class="v-file__hover-title">{{info}}</div>
            </div>
            <img v-if="btnList?.length > 0" src="@/assets/images/icons/edit.svg" alt="edit" @click.stop="emit('openMenu', file.id)"/>
            <div class="v-file__menu" v-if="showMenu === file?.id">
              <div class="v-file__menu-item" @click="fileEdit(file.id)" v-if="btnList?.includes('edit')">
                <div>
                  <img src="@/assets/images/icons/btn/edit.svg" alt="title" />
                </div>
                Изменить
              </div>
              <div class="v-file__menu-item" @click.stop="cancel(file.id)" v-if="btnList?.includes('cancel')">
                <div>
                  <img src="@/assets/images/icons/btn/cancel.svg" alt="title" />
                </div>
                Отменить
              </div>
              <div class="v-file__menu-item" @click="restore(file.id)" v-if="btnList?.includes('restore')">
                <div>
                  <img src="@/assets/images/icons/btn/restore.svg" alt="title" />
                </div>
                Восстановить
              </div>
              <div class="v-file__menu-item" @click="deleteFile"  v-if="btnList?.includes('delete')">
                <div>
                  <img src="@/assets/images/icons/btn/trash.svg" alt="title" />
                </div>
                Удалить
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref, watch} from "vue";
import responses from "@/api/responses";
import {useRoute} from "vue-router";

const emit = defineEmits([
  "delete",
  "edit",
  "cancel",
  "restore",
  "updateFileData",
  "openMenu",
  "closeMenu"
]);

const props = defineProps({
  file: Object,
  deleteBtn: {
      type: Boolean,
      default: false
  },
  count: {
    type: Number,
    default: 0
  },
  info: String,
  btnList: [Array, Object],
  showMenu: {
    type: String,
    default: ''
  },
})

const route = useRoute();
const title = ref(false)

const fileEdit = (id) => {
  emit("edit", id);
  emit("closeMenu")
}

const cancel = async (id) => {
  emit("closeMenu")
  const response = await responses.patchResponsesTicketsUpdate(
      route.params?.id,
      Number(route.query?.stage) + 1,
      id,
      {action: "cancel"}
  )
  emit("updateFileData", response.route[Number(route.query?.stage)]?.tickets)
}

const restore = async (id) => {
  const response = await responses.patchResponsesTicketsUpdate(
      route.params?.id,
      Number(route.query?.stage) + 1,
      id,
      {action: "restore"}
  )
  emit("updateFileData", response.route[Number(route.query?.stage)]?.tickets)
  emit("closeMenu")
}

const deleteFile = () => {
  emit("delete")
  emit("closeMenu")
}

function declensionFiles(count) {
  if (isNaN(count)) return '0 файлов'; // если передано не число

  const lastTwo = Math.abs(count) % 100;
  const lastOne = lastTwo % 10;

  if (lastTwo > 10 && lastTwo < 20) return `${count} файлов`;
  if (lastOne === 1) return `${count} файл`;
  if (lastOne >= 2 && lastOne <= 4) return `${count} файла`;

  return `${count} файлов`;
}

const onOuterSettingsClick = function (e) {
  if (!e.target.closest(".header-main__settings-dropdown") && props.showMenu) {
    emit("closeMenu")
  }
};
onMounted(() => {
  document.addEventListener("click", onOuterSettingsClick);
});

onUnmounted(() => {
  document.removeEventListener("click", onOuterSettingsClick);
});
</script>

<style scoped lang="scss">
.v-file {
  height: 56px;
  padding: 0 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: $light;

  &__content {
      display: flex;
      align-items: center;
  }

  &__text {
      margin-left: 12px;
  }

  &__title {
      width: 100px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }

  &__size {
      margin-top: 4px;
      color: $gray;
      font-size: 12px;
  }

  &__delete {
      cursor: pointer;
  }

  &__form-bottom-upload-options {
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;

    img {
      cursor: pointer;
    }
  }

  &__hover-menu {
    position: relative;
    margin-top: 3px;
  }

  &__hover-title {
    position: absolute;
    padding: 12px 16px;
    font-size: 14px;
    width: 135px;
    right: -55px;
    z-index: 11;
    top: 20px;
    border: 1px solid $light-gray-2;
    border-radius: 8px;
    background-color: white;
  }

  &__menu {
    position: absolute;
    top: 30px;
    left: -130px;
    background-color: white;
    width: 165px;
    padding: 8px ;
    border-radius: 8px;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.12);
    z-index: 10;
  }
  &__menu-item {
    padding: 8px;
    font-weight: 500;
    font-size: 14px;
    color: $dark-blue;
    text-decoration: none;
    height: 40px;
    display: flex;
    gap: 4px;
    align-items: center;
    cursor: pointer;

    img {
      margin-top: 3px;
    }
  }
}
</style>
